/**管理员-系统指定角色KEY */
export const ADMIN_ROLE_KEY = 'admin';

/**管理员-系统指定权限 */
export const ADMIN_PERMISSION = '*:*:*';
